import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Staff-only: internal notes (never shown to clients) and client-visible feedback recorded on the client's behalf (flagged). Neither changes a decision.
export function OfferInternalNotes({ enquiryId, offer: o, onChanged }) {
  const [note, setNote] = useState("");
  const [kind, setKind] = useState("internal");
  const [busy, setBusy] = useState(false);
  const add = async () => {
    setBusy(true);
    try { await api.post(`/enquiries/${enquiryId}/client-offers/${o.id}/${kind === "internal" ? "internal-note" : "feedback"}`, { text: note.trim() }); setNote(""); toast.success(kind === "internal" ? "Internal note added" : "Client-visible feedback recorded (flagged as recorded by Jigsaw)"); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-1" data-testid={`offer-internal-${o.id}`}>
      {(o.internal_notes || []).map((n) => <p key={n.id} className="text-[12px] text-jigsaw-muted" data-testid={`offer-internal-note-${n.id}`}><span className="rounded bg-jigsaw-bg px-1 text-[10px] uppercase tracking-wide">internal</span> {new Date(n.at).toLocaleDateString("en-GB")}: {n.text}</p>)}
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid={`offer-note-kind-${o.id}`} value={kind} onChange={(e) => setKind(e.target.value)} className="h-8 rounded-md border border-jigsaw-border bg-white px-2 text-[12px]"><option value="internal">Internal note (staff only)</option><option value="feedback">Client feedback (on their behalf)</option></select>
        <Input data-testid={`offer-note-text-${o.id}`} value={note} maxLength={1000} onChange={(e) => setNote(e.target.value)} placeholder={kind === "internal" ? "Not visible to the client" : "Visible to the client, flagged as recorded by Jigsaw"} className="h-8 flex-1 min-w-[12rem] text-[12px]" />
        <Button size="sm" variant="outline" data-testid={`offer-note-add-${o.id}`} disabled={busy || !note.trim()} onClick={add}>Add</Button>
      </div>
    </div>
  );
}
